/* src/Interviews/InterviewFormCard/styles.js */

export default theme => ({
  paper: {
    height: theme.spacing.unit * 102,
    overflow: 'auto',
  },
  addQuestionCard: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: theme.spacing.unit * 75,
    transform: 'translate(-50%, -50%)',
  },
  textFieldContainer: {
    padding: theme.spacing.unit * 3,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: theme.spacing.unit,
    marginTop: 0,
  },
});



// WEBPACK FOOTER //
// ./src/modules/interviews/cards/InterviewFormCard/styles.js